/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
import type { Status } from './Status.js';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status.js';

/**
 * Bulk patch notifications for the authenticated user
 * @export
 * @interface NotificationBulkPatch
 */
export interface NotificationBulkPatch {
    /**
     * 
     * @type {Status}
     * @memberof NotificationBulkPatch
     */
    status: Status;
}

/**
 * Check if a given object implements the NotificationBulkPatch interface.
 */
export function instanceOfNotificationBulkPatch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function NotificationBulkPatchFromJSON(json: any): NotificationBulkPatch {
    return NotificationBulkPatchFromJSONTyped(json, false);
}

export function NotificationBulkPatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationBulkPatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': StatusFromJSON(json['status']),
    };
}

export function NotificationBulkPatchToJSON(value?: NotificationBulkPatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': StatusToJSON(value.status),
    };
}

